import React from 'react';
import styles from '../../pages/Monitor/Monitor.module.css';
import SensorControlCard from './SensorControlCard';

const SensorGrid = ({ 
    type, 
    count, 
    label, 
    icon, 
    unit, 
    sensorData, 
    suspendedSensors, 
    onUpdate, 
    CardComponent = SensorControlCard,
    customNames = {},
    onSaveCustomName,

    // جدید
    serial,
    token
}) => {
    const items = [];

    for (let i = 0; i < count; i++) {
        const key = `${type}${i}`;
        const data = sensorData[key];

        if (data && data.connected && !suspendedSensors.has(key)) {
            items.push(
                <CardComponent
                    key={key}
                    type={type}
                    index={i}
                    label={`${label} ${i}`}
                    icon={icon}
                    unit={unit}
                    data={data}
                    onUpdate={(prop, val) => onUpdate(type, i, prop, val)}
                    customNames={customNames}
                    onSaveCustomName={onSaveCustomName}

                    // جدید
                    serial={serial}
                    token={token}
                />
            );
        }
    }

    if (items.length === 0) {
        return <div className={styles.emptySection}>موردی برای نمایش در این بخش یافت نشد.</div>;
    }

    return <div className={styles.sensorsGrid}>{items}</div>;
};

export default SensorGrid;